import React from 'react';

// Types
import { GoalItem } from 'Shared/constants/types';

// Hooks
import { useGoal } from 'Shared/utils/hooks/use-goal';
import { useGoalDetailPanel } from 'Shared/utils/hooks/use-goal-detail-panel';

// Components
import { WpBreadcrumbs, WpBreadcrumbItem } from 'Wpds/components/breadcrumbs';

type Props = {
  goal: GoalItem;
};

const GoalDetailPanelBreadcrumbs = ({ goal }: Props) => {
  const { handleOpenPanel } = useGoalDetailPanel();
  const { parentGoal } = useGoal({ slug: goal.slug });

  const handleOnClick = () => {
    handleOpenPanel(parentGoal.slug);
  };

  if (!parentGoal) return null;

  return (
    <WpBreadcrumbs>
      <WpBreadcrumbItem label={parentGoal.name} onClick={handleOnClick} />
      <WpBreadcrumbItem label={goal.name} />
    </WpBreadcrumbs>
  );
};

export default GoalDetailPanelBreadcrumbs;
